// extracted by mini-css-extract-plugin
export default {"maintenanceText":"ach-maintenance-notice_maintenanceText__H2Xbx"};